if (!customElements.get("input-tel-intl")) {
  class InputTelIntl extends HTMLElement {
    static _libPromise = null;
    static CSS_URL =
      "https://cdn.jsdelivr.net/npm/intl-tel-input@25.4.5/build/css/intlTelInput.min.css";
    static JS_URL =
      "https://cdn.jsdelivr.net/npm/intl-tel-input@25.4.5/build/js/intlTelInput.min.js";
    static CSS_MARK = "data-iti-css";
    static JS_MARK = "data-iti-js";

    constructor() {
      super();
      this.input = null;
      this.iti = null;
      this._initialized = false;

      this._resolveItiReady = null;
      this.itiReady = new Promise(
        (resolve) => (this._resolveItiReady = resolve)
      );
    }

    static ensureLib() {
      if (window.intlTelInput) return Promise.resolve();
      if (this._libPromise) return this._libPromise;

      this._libPromise = new Promise((resolve, reject) => {
        if (!document.querySelector(`link[${this.CSS_MARK}="1"]`)) {
          const css = document.createElement("link");
          css.rel = "stylesheet";
          css.href = this.CSS_URL;
          css.setAttribute(this.CSS_MARK, "1");
          document.head.appendChild(css);
        }

        if (window.intlTelInput) {
          resolve();
          return;
        }

        let script = document.querySelector(`script[${this.JS_MARK}="1"]`);
        if (!script) {
          script = document.createElement("script");
          script.src = this.JS_URL;
          script.setAttribute(this.JS_MARK, "1");
          script.onload = () => resolve();
          script.onerror = reject;
          document.head.appendChild(script);
        } else {
          script.addEventListener("load", () => resolve(), { once: true });
          script.addEventListener("error", reject, { once: true });
        }
      });

      return this._libPromise;
    }

    connectedCallback() {
      if (this._initialized) return;

      this.input = this.querySelector('input[type="tel"]');
      if (!this.input) return;

      this._initialized = true;
      this.initPhoneField();
    }

    async initPhoneField() {
      await this.constructor.ensureLib();
      if (this.iti || !this.input) return;

      const country = (this.dataset.initialCountry || "us").toLowerCase();

      this.iti = window.intlTelInput(this.input, {
        initialCountry: country,
        useFullscreenPopup: false,
        separateDialCode: true,
        preferredCountries: ["us", "gb"],
      });

      this.positionLabel();
      this.input.addEventListener("countrychange", () => this.positionLabel());

      this._resolveItiReady?.(this.iti);
      this.dispatchEvent(
        new CustomEvent("iti-ready", { detail: { iti: this.iti } })
      );
    }

    positionLabel() {
      const label = this.querySelector(".iti-phone-label");
      const countryContainer = this.querySelector(".iti__country-container");
      if (!label || !this.input || !countryContainer) return;

      requestAnimationFrame(() => {
        const containerWidth = countryContainer.offsetWidth;
        const gap = 16;
        const left = containerWidth + gap;
        this.input.style.paddingLeft = left + "px";
        label.style.left = left + "px";
      });
    }

    async setActiveCountry(iso2) {
      await this.itiReady;
      if (!iso2 || !this.iti) return;
      this.iti.setCountry(iso2);
    }

    format(phoneVal) {
      const sanitizedPhone = (phoneVal || "").replace(/\D/g, "");
      return `+${this.iti.getSelectedCountryData().dialCode}${sanitizedPhone}`;
    }
  }

  customElements.define("input-tel-intl", InputTelIntl);
}
